import(/* webpackMode: "eager", webpackExports: ["ContentLandingPageApp"] */ "/home/runner/work/monorepo/monorepo/apps/beemo/app/contenido/[contentId]/client.tsx");
